const DEFAULT_RANDOM_CHARS = 'abcdefghijklmkopqrstuvwxyz0123456789';
const defaultRNG = (a)=>{
    if (window?.crypto !== null && window?.crypto !== void 0) window.crypto.getRandomValues(a);
    else for(let i = 0; i < a.length; i++)a[i] = Math.random() % 255;
};
const fakeRNG = (a)=>{
    for(let i = 0; i < a.length; i++)a[i] = 255 - i % 255;
};
let rng = defaultRNG;
function usingDefaultRNG() {
    rng = defaultRNG;
}
function usingRNG(override) {
    rng = override;
}
function randomString(len = 32, charset = DEFAULT_RANDOM_CHARS) {
    const randomBytes = new Uint8Array(len);
    rng(randomBytes);
    const randomChars = randomBytes.map((n)=>charset.charCodeAt(Math.abs(n) % charset.length));
    return String.fromCharCode(...Array.from(randomChars));
}
export { fakeRNG, randomString, usingDefaultRNG, usingRNG };

//# sourceMappingURL=random.js.map